// extracted by mini-css-extract-plugin
export default {"imgDiv":"Equ_imgDiv__KCBy5","img":"Equ_img__9byWm","hover":"Equ_hover__5gjOy"};